module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Newsletter subscription","placeholder":"Enter your email","subscription-already-exists":"You are already subscribed"},"ru":{"title":"Подписка на email-рассылку","placeholder":"Ваш email","success":"Вы успешно подписаны на e-mail рассылку. Проверьте вашу почту!","subscription-already-exists":"Вы уже подписаны"}}')
  delete Component.options._Ctor
}
